// extracted by mini-css-extract-plugin
export default {"title":"classes_title__fBDHB","text":"classes_text__5zaL-","link":"classes_link__Hg7I7","list":"classes_list__Re6Hf"};